var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col bg-white z-10"},[_c('banner',{attrs:{"full":_vm.full}}),_c('navbar'),(_vm.breadcrumb)?_c('breadcrumb'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }